/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Top Nav Filter Icon component.
 */
export const TopNavFilterIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_14304_19695)'>
        <path d='M1 11.25H4.24996M8.24996 11.25H15.5' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
        <circle cx='6.25' cy='11.5' r='1.75' stroke={iconColor} strokeWidth='1.5'/>
        <path d='M15.5 4.75L12.25 4.75M8.25004 4.75L1.00004 4.75' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
        <circle cx='10.25' cy='4.5' r='1.75' transform='rotate(-180 10.25 4.5)' stroke={iconColor} strokeWidth='1.5' />
      </g>
      <defs>
        <clipPath id='clip0_14304_19695'>
          <rect width={iconSize} height={iconSize} fill={dlsColor('white')} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TopNavFilterIcon;
